/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  showHook(hookId) {
    return axios.get(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  updateHook({ hookId, hookData }) {
    return axios.patch(
      `${this.baseUrl()}/integrations/hooks/${hookId}`,
      hookData
    );
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  validateCorban(data) {
    return axios.post(
      `${this.baseUrl()}/integrations/hooks/validate_corban`,
      data
    );
  }

  validateBanking(data) {
    return axios.post(
      `${this.baseUrl()}/integrations/hooks/validate_banking`,
      data
    );
  }

  registerSomaWebhook(data) {
    return axios.post(
      `${this.baseUrl()}/integrations/hooks/register_soma_webhook`,
      data
    );
  }

  bankingTables(data) {
    return axios.post(
      `${this.baseUrl()}/integrations/hooks/banking_tables`,
      data
    );
  }

  c6TypistCode(data) {
    return axios.post(
      `${this.baseUrl()}/integrations/hooks/c6_typist_code`,
      data,
      { timeout: 120000 }
    );
  }

  connectShopify({ shopDomain }) {
    return axios.post(`${this.baseUrl()}/integrations/shopify/auth`, {
      shop_domain: shopDomain,
    });
  }
}

export default new IntegrationsAPI();
